let presets = [
    {
        name: 'Simple Example',
        description: 'Example of simple sphere',
        code: '5iGW5G6Lyh48uoy8toEy'
    },
    {
        name: 'Cube Plus Sphere',
        description: 'Example of usage of the "add Funtion" node',
        code: 'nOPzejvzkctWqGAlRGAI'
    },
    {
        name: 'Custom Function',
        description: 'Example of usage of the custom node',
        code: 'bxxp2ZdnQYv2ZT7AdQM6'
    },
    {
        name: 'Animation',
        description: 'Example of usage of the animation node',
        code: 'XDDiXzVIy6zrgKBhNble'
    },
    {
        name: 'Multiple Outputs',
        description: 'Example of multiple outputs with diferent materials',
        code: '6tVrzUeGFIj7iJ9Nww3U'
    },
    {
        name: 'Multiply Functions',
        description: 'Example of the multiply node',
        code: '1kaQERcfMC2seddHLJRe'
    },
    {
        name: 'Math And Index Color',
        description: 'Example of the math node and the index color node',
        code: 'e0v90fWiIdO3Stfb7SqR'
    },

]

export default presets

